import { Injectable }      from "@angular/core";
import { HttpClient }      from "@angular/common/http";
import { environment } from '../../environments/environment';
import { SettingsService } from "./settings.service";

@Injectable({
	providedIn: 'root'
})
export class HttpService {

	get serverUrl(): string{
		return environment.serverUrl;
	}

	constructor(protected http:HttpClient,protected settings:SettingsService) {
	}


	protected async get<T>(endpoint: string, logError = true): Promise<T> {
		try {
			return <T>(await this.http.get(`${this.serverUrl}/${endpoint}`).toPromise());
		} catch (e) {
			if (logError) {
				console.error('HTTP GET /' + endpoint + ' error: ', e);
				return null;
			} else {
				throw e;
			}
		}
	}

	protected async getString(endpoint: string, logError = true): Promise<string> {
		try {
			return await this.http.get(`${this.serverUrl}/${endpoint}`,
				{ responseType: 'text' as 'text' }).toPromise<string>();
		} catch (e) {
			if (logError) {
				console.error('HTTP GET /' + endpoint + ' error: ', e);
				return null;
			} else {
				throw e;
			}
		}
	}

	protected async post<T>(endpoint: string, data:any = null, logError = true): Promise<T> {
		try {
			return await this.http.post<T>(`${this.serverUrl}/${endpoint}`, data).toPromise();
		} catch (e) {
			if (logError) {
				console.error('HTTP POST /' + endpoint + ' error: ', e);
				return null;
			} else {
				throw e;
			}
		}
	}

	protected async delete<T>(endpoint: string, logError = true): Promise<T> {
		try {
			return await this.http.delete<T>(`${this.serverUrl}/${endpoint}`).toPromise();
		} catch (e) {
			if (logError) {
				console.error('HTTP DELETE /' + endpoint + ' error: ', e);
				return null;
			} else {
				throw e;
			}
		}
	}

	protected async put<T>(endpoint: string, data:any = null, logError = true): Promise<T> {
		try {
			return await this.http.put<T>(`${this.serverUrl}/${endpoint}`,data).toPromise();
		} catch (e) {
			if (logError) {
				console.error('HTTP PUT /' + endpoint + ' error: ', e);
				return null;
			} else {
				throw e;
			}
		}
	}

	protected async patch<T>(endpoint: string, data:any = null, logError = true): Promise<T> {
		try {
			return await this.http.patch<T>(`${this.serverUrl}/${endpoint}`,data).toPromise();
		} catch (e) {
			if (logError) {
				console.error('HTTP PUT /' + endpoint + ' error: ', e);
				return null;
			} else {
				throw e;
			}
		}
	}
}
